module.exports = __webpack_public_path__ + "media/recipes/47-2a1c012f.png";